import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    id: "realizations",
    class: "realizations"
};
const _hoisted_2 = { class: "realizations__grid" };
const _hoisted_3 = { class: "realizations__copy" };
const _hoisted_4 = { class: "realizations__label" };
const _hoisted_5 = { class: "realizations__title" };
const _hoisted_6 = { class: "realizations__body" };
const _hoisted_7 = { class: "realizations__list" };
const _hoisted_8 = { class: "realizations__icon" };
const _hoisted_9 = {
    key: 0,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
};
const _hoisted_10 = {
    key: 1,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
};
const _hoisted_11 = {
    key: 2,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
};
const _hoisted_12 = {
    key: 3,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
};
const _hoisted_13 = {
    key: 4,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
};
const _hoisted_14 = {
    key: 5,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
};
const _hoisted_15 = { class: "realizations__cards" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RotatingCards = _resolveComponent("RotatingCards");
    const _directive_reveal = _resolveDirective("reveal");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('realizations.label')), 1),
                _createElementVNode("h2", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t('realizations.titlePre')) + " ", 1),
                    _createElementVNode("em", null, _toDisplayString(_ctx.$t('realizations.titleItalic')), 1),
                    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('realizations.titlePost')), 1)
                ]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('realizations.body')), 1),
                _createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: item.label,
                            class: "realizations__item"
                        }, [
                            _createElementVNode("span", _hoisted_8, [
                                (item.icon === 'camera')
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                                            _createElementVNode("path", { d: "M3 7h3l2-3h8l2 3h3v12H3z" }, null, -1),
                                            _createElementVNode("circle", {
                                                cx: "12",
                                                cy: "13",
                                                r: "4"
                                            }, null, -1)
                                        ]))]))
                                    : (item.icon === 'film')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                                                _createElementVNode("rect", {
                                                    x: "3",
                                                    y: "4",
                                                    width: "18",
                                                    height: "16",
                                                    rx: "1.5"
                                                }, null, -1),
                                                _createElementVNode("path", { d: "M3 8h18M3 16h18M7 4v16M17 4v16" }, null, -1)
                                            ]))]))
                                        : (item.icon === 'pen')
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[3] || (_cache[3] = [
                                                    _createElementVNode("path", { d: "M14 4l6 6-11 11H3v-6z" }, null, -1),
                                                    _createElementVNode("path", { d: "M13 5l6 6" }, null, -1)
                                                ]))]))
                                            : (item.icon === 'share')
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[4] || (_cache[4] = [
                                                        _createElementVNode("circle", {
                                                            cx: "6",
                                                            cy: "12",
                                                            r: "2.4"
                                                        }, null, -1),
                                                        _createElementVNode("circle", {
                                                            cx: "18",
                                                            cy: "6",
                                                            r: "2.4"
                                                        }, null, -1),
                                                        _createElementVNode("circle", {
                                                            cx: "18",
                                                            cy: "18",
                                                            r: "2.4"
                                                        }, null, -1),
                                                        _createElementVNode("path", { d: "M8 11l8-4M8 13l8 4" }, null, -1)
                                                    ]))]))
                                                : (item.icon === 'pin')
                                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_13, [...(_cache[5] || (_cache[5] = [
                                                            _createElementVNode("path", { d: "M12 22s7-7.6 7-13a7 7 0 1 0-14 0c0 5.4 7 13 7 13z" }, null, -1),
                                                            _createElementVNode("circle", {
                                                                cx: "12",
                                                                cy: "9",
                                                                r: "2.6"
                                                            }, null, -1)
                                                        ]))]))
                                                    : (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[6] || (_cache[6] = [
                                                            _createElementVNode("path", { d: "M3 20h18" }, null, -1),
                                                            _createElementVNode("path", { d: "M6 16v-4M11 16V8M16 16v-6M21 16V5" }, null, -1)
                                                        ]))]))
                            ]),
                            _createElementVNode("span", null, _toDisplayString(item.label), 1)
                        ]));
                    }), 128))
                ])
            ])), [
                [_directive_reveal]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_RotatingCards, {
                    items: _ctx.cards,
                    "extend-right": 1,
                    "prev-label": _ctx.$t('realizations.prev'),
                    "next-label": _ctx.$t('realizations.next')
                }, null, 8, ["items", "prev-label", "next-label"])
            ])), [
                [_directive_reveal, { delay: 140 }]
            ])
        ])
    ]));
}
